const reportDB = require('../../../../../components/report/report-db')
const report = require('../../../../../components/report/report')
const style = require('../../../../../components/report/report-style')
const css = style.get()
const { tableDetail } = require('./inventory-dt-handler')





export function start(detail) {   
  
  const phpFile = 'server/php/sql/report.php'
  const dt = document.getElementById('inventory-dt')

  const mainFilter = { fields: [], values: [] }
  mainFilter.fields = tableDetail.filter.mainFilterFields

  let searchValue = dt.querySelector('.header input').value
  if (searchValue.length < 3) { searchValue = "" }

  if (searchValue != "" || searchValue === "") {
    for (let i = 0; i < mainFilter.fields.length; i++) {
      mainFilter.values.push(searchValue)
    }

  } else {//if the search is empy, add the default values
    mainFilter.values = tableDetail.filter.mainFilterValues
  }

  let filterCont   = dt.querySelector('.filterCont')
  let searchFilter = filterCont.querySelectorAll('input')	

  const andFilter = { fields: [], values: [] }
  mainFilter.fields = tableDetail.filter.mainFilterFields

  searchFilter.forEach((elem)=>{
    if(elem.value != ""){ 
        andFilter.fields.push(elem.getAttribute('data-field'))
        andFilter.values.push(elem.value)
    }    
  })



  detail.inf = { entity: 'inventory', report: 'inventory-report-item-available',
                 mainFilter: JSON.stringify(mainFilter), andFilter: JSON.stringify(andFilter) }

  reportDB.select(detail, phpFile, (data) => { //console.log('reportTest 5>', data)
    //console.log('reportTest 5>', data)
    insert(detail, data)

  })


}/**/


function insert(detail, data) { //console.log('REPORT maixxxx>', style.start('f32'))

  report.show(detail, () => {


    const pageTarget = document.getElementById('inventory-page-right')
    const body = generate(data)

    pageTarget.insertAdjacentHTML("beforeend", body)

  })

}/*insert*/





function generate(data) { 

  var body = ''


  const Item = data

  body += generateHeader("")
  body += generateItemTable(Item)



  body += `</div> <!-- dataCont -->`
  body += `<div class="report-page">`

  return body
}

function generateHeader(data) {

  var header = ''
  header += `<div class="report-page" id="miDiv5" ${css.table}>`
  header += `
                    <div class="report-appbar report-appbar-black" >

                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"report", "act":"remove" } ] }' >
                                <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                            </div>

                            <h1>Report</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> <!-- appbar -->
            `

  header += `
                    <div class="dataCont">
                        <h1  ${css.f32}>Inventory Status Report</h1>
                        <p   ${css.f14}>This report shows the main information about the items available in inventory.</p>
            `
  return header


}


function generateItemTable(item) {

  var table = `
              <h2 ${css.tableTitle}>Inventory Item</h2>                        
              <table ${css.table} >
                <tr>
                  <th ${css.th}>Name</th>
                  <th ${css.th}>Brand</th>
                  <th ${css.th}>Available</th>
                  <th ${css.th}>Units</th>
                  <th ${css.th}>AVG. Purchase Price</th>
                  <th ${css.th}>Last Purchase Price</th>
                  <th ${css.th}>AVG. Selling Price</th>
                  <th ${css.th}>Last Selling Price</th>
                </tr> 
        `


  if (item.length > 0) {
       
    for (let i = 0; i < item.length; i++) { //console.log('for>>>', soldItem.length)

      let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
       {"dest":"inventory", "elem":"dt", "id":"inventory-dt", "act":"dialogUpdateSellingPrice", 
                                "dbid":"${item[i].item_id}", "item_name":"${item[i].item_name}", "item_unit_id":"${item[i].item_unit_id}",
                                "item_unit_name":"${item[i].item_unit_name}" } ] }'`

      table += `
                <tr>
                  <td ${css.td}>${item[i].item_name}</td>
                  <td ${css.td}>${item[i].brand}</td>
                  <td ${css.td}>${item[i].available}</td>
                  <td ${css.td}>${item[i].item_unit_name}</td>
                  <td ${css.td}>${cashVal(item[i].avg_purchase_price)}</td>
                  <td ${css.td}>${cashVal(item[i].last_purchase_price)}</td>
                  <td ${css.td}>${cashVal(item[i].avg_selling_price)}</td>
                  <td   class='tdClick' ${detailHtml} ${css.td}>${cashVal(item[i].last_sale_price)}</td>
                </tr> 
            `
    }
  }

  table += `</table>`

  return table
}


function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
function rowStyle(i) {

  if (i % 2 === 0) { return '' }
  return css.trGray

}

